import { usePendingOrgBillingTransferQuery } from "@api/orgBillingTransferRecipient.api";
import { useTypedFlags } from "@hooks/useTypedFlags";
import { useScope } from "@state/scopeContext.lib";

export function usePendingOrgBillingTransfer() {
    const { workspaceId } = useScope();
    const { orgBillingTransferRequests: isTransferRequestsEnabled } =
        useTypedFlags();
    const { data: request } = usePendingOrgBillingTransferQuery({
        workspaceId,
        enabled: isTransferRequestsEnabled,
    });

    return isTransferRequestsEnabled ? (request ?? null) : null;
}
